import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import Croppie from 'croppie/croppie';
import { Store } from '@ngxs/store';
import { UploadPhoto } from '../../propriete.state';
import { HideLoader, ShowLoader, ShowPopup } from '../../../shared/personne.state';
import { GtmService } from '../../../shared/services/gtm.service';
import { GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES } from '../../../shared/modeles/variables';
import { PhotoUpload } from '../../../shared/modeles/photo-upload.modele';

@Component({
  selector: 'app-edit-photo',
  templateUrl: './edit-photo.component.html',
  styleUrls: ['./edit-photo.component.scss'],
  standalone: false
})
export class EditPhotoComponent implements OnInit {
  @Output()
  savePhoto: EventEmitter<PhotoUpload> = new EventEmitter();

  @ViewChild('fileInput')
  fileInput: ElementRef;

  croppie: Croppie;
  photoOriginalName: string;
  isVisible: boolean;
  hasPhoto: boolean;
  isProcessing: boolean;

  constructor(private readonly _store: Store, private readonly _gtm: GtmService) {}

  ngOnInit() {
    this.hasPhoto = false;
    this.isVisible = false;
    this.isProcessing = false;
    this.photoOriginalName = null;

    this.croppie = new Croppie(document.getElementById('photo-preview'), {
      viewport: {
        width: 375,
        height: 164,
        type: 'square'
      },
      enableExif: true,
      enableOrientation: true
    });
  }

  openFileBrowser() {
    const element: HTMLElement = document.getElementById('photo-propriete');
    element.click();
  }

  onImageChange($event) {
    if ($event && $event.target.files && $event.target.files[0]) {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        this.croppie.bind({
          url: e.target.result
        });
        this.hasPhoto = true;
        this.isVisible = true;
      };

      reader.readAsDataURL($event.target.files[0]);
      this.photoOriginalName = $event.target.files[0].name;
    }
  }

  rotateRight() {
    this.croppie.rotate(-90);
  }

  save() {
    this.isProcessing = true;
    this._store.dispatch(new ShowLoader());

    this.croppie
      .result({
        type: 'blob',
        size: {
          width: 1024
        },
        format: 'jpeg',
        quality: 0.8
      })
      .then(blob => {
        this._store
          .dispatch(new UploadPhoto(blob, this.photoOriginalName))
          .toPromise()
          .then((state: any) => {
            if (state.propriete.lastUploadedImage) {
              this.savePhoto.emit(state.propriete.lastUploadedImage);
            }

            this._store.dispatch(new HideLoader());
            this.isProcessing = false;
            this.close();
          })
          .catch(err => {
            let errorType = 'internal';

            if (err.status === 400 || err.status === 422) {
              errorType = err.error && err.error.statut === 'alerte-content-moderator' ? 'moderated' : 'size';
            }

            this.pushErrorEvent(errorType);

            this.isProcessing = false;
            this.close();
            this._store.dispatch(new ShowPopup('photo-error', errorType));
            this._store.dispatch(new HideLoader());
          });
      });
  }

  close() {
    this.isVisible = false;
    this.hasPhoto = false;
    this.fileInput.nativeElement.value = '';
  }

  pushErrorEvent(errorType) {
    this._gtm.pushEvent({
      event: GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES,
      category: 'Parcours habitation - erreur',
      label: errorType,
      action: 'erreur photo',
      value: 0,
      nonInteraction: false
    });
  }
}
